<template>
  <section class="section tile is-ancestor my-6 pt-6">
    <div class="tile is-parent is-vertical">
      <div class="container tile is-vertical">
        <div class="container  mt-6">
          <img width="100" :src="require('@/assets/imagotipo.png')" alt="FecMX" class="center" />
        </div>

        <h1 class="title has-text-centered has-text-secondary">APPLY NOW</h1>
        <h2 class="title has-text-centered has-text-primary pt-3">Junior Controls Engineer</h2>
        <h3 class="subtitle has-text-centered mt-4">Fastening Electric Controls USA LLC</h3>

        <div class="content mt-5">
          <p>
            The Junior Controls Engineer will participate in system testing and debugging, support the installation and
            commissioning of automation systems, and conduct system validations to ensure functionality and compliance
            with engineering standards.
            The role involves creating and maintaining technical documentation, including electrical schematics and
            wiring diagrams, while ensuring adherence to industry regulations and safety protocols.
          </p>
        </div>

        <div class="content mt-6 tile is-vertical">
          <h3 class="has-text-weight-semibold is-size-4">Duties:</h3>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Design & Development</h4>
          <ul>
            <li>Assist in designing and programming PLC and HMI systems.</li>
            <li>Develop control logic using ladder logic, function block, or structured text code.</li>
            <li>Support sensor, actuator, and control system integration.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Testing & Implementation</h4>
          <ul>
            <li>Help with testing, debugging, and troubleshooting control systems.</li>
            <li>Support automation system installation and commissioning.</li>
            <li>Conduct system validations to meet design requirements.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Maintenance & Troubleshooting</h4>
          <ul>
            <li>Diagnose and resolve automation equipment issues.</li>
            <li>Perform routine maintenance and software updates.</li>
            <li>Collaborate with engineers and technicians to improve performance.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Documentation & Compliance</h4>
          <ul>
            <li>Create and maintain schematics, wiring diagrams, and control docs.</li>
            <li>Ensure compliance with safety and industry standards.</li>
            <li>Prepare technical reports and manuals.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Collaboration & Continuous Improvement</h4>
          <ul>
            <li>Work with engineers and production to improve efficiency.</li>
            <li>Assist R&D with new automation technologies.</li>
            <li>Stay current with industrial control system advancements.</li>
          </ul>
        </div>

        <div class="content mt-6">
          <p><strong>Location:</strong> 5805 CALLAGHAN RD #116 SAN ANTONIO, TEXAS 782289</p>
          <p><strong>Send your cv to:</strong> <a href="mailto:	facturas@fecmx.co">facturas@fecmx.co</a></p>
        </div>

        <hr class="my-6" />

        <!-- Mechanical Engineer Section -->
        <h2 class="title has-text-centered has-text-primary pt-3">Mechanical Engineer</h2>
        <h3 class="subtitle has-text-centered mt-4">Fastening Electric Controls USA LLC</h3>

        <div class="content mt-5">
          <p>
            The duties of the Mechanical Engineer are the following:
          </p>
        </div>

        <div class="content mt-6 tile is-vertical">
          <h3 class="has-text-weight-semibold is-size-4">Duties:</h3>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Mechanical Design & Development</h4>
          <ul>
            <li>Designing mechanical components and assemblies using CAD tools (e.g., SolidWorks, AutoCAD).</li>
            <li>Supporting mechanical integration of sensors, actuators, and automation hardware.</li>
            <li>Developing prototypes and test setups for new mechanical systems.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Automation Integration & Implementation</h4>
          <ul>
            <li>Assisting in integrating mechanical systems with automation equipment such as robots and conveyors.</li>
            <li>Supporting system installations and ensuring mechanical compatibility with control elements.</li>
            <li>Conducting dry runs and system validations to confirm mechanical performance.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Manufacturing & Production Processes</h4>
          <ul>
            <li>Applying knowledge of stamping, welding, machining, and assembly processes.</li>
            <li>Supporting process layout optimization to improve cycle times and efficiency.</li>
            <li>Assisting in the selection of materials and components based on production needs.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Troubleshooting & Continuous Improvement</h4>
          <ul>
            <li>Diagnosing mechanical failures and recommending design or process changes.</li>
            <li>Participating in root cause analysis and implementing corrective actions.</li>
            <li>Contributing to Lean Manufacturing or Six Sigma initiatives to reduce waste and defects.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Documentation & Standards Compliance</h4>
          <ul>
            <li>Preparing technical drawings, BOMs, and documentation for manufacturing.</li>
            <li>Ensuring designs comply with automotive standards and safety regulations.</li>
            <li>Maintaining updated documentation aligned with ISO/TS and internal quality systems.</li>
          </ul>

          <h4 class="has-text-weight-semibold is-size-5 mt-4">Collaboration & Project Support</h4>
          <ul>
            <li>Working with controls, electrical, and manufacturing engineers to integrate systems.</li>
            <li>Assisting in project planning, scheduling, and task tracking.</li>
            <li>Communicating clearly with cross-functional teams and external vendors.</li>
          </ul>
        </div>
        <div class="content mt-6">
          <p><strong>Location:</strong> 5805 CALLAGHAN RD #116 SAN ANTONIO, TEXAS 782289</p>
          <p><strong>Send your cv to:</strong> <a href="mailto:	facturas@fecmx.co">facturas@fecmx.co</a></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "JuniorControlsEngineerView"
};
</script>

<style scoped>
ul {
  list-style-type: disc;
  margin-left: 1.5rem;
}
</style>
